import authUserActions from '../authuser/actions';
import actions from "../serviceuser/serviceusers/actions";
import providerUserActions from "../providerusers/actions";
import auditActions from "../audit/actions";
import _ from "lodash";

const initState = {
  personalDetailsMap: {},
  usersMap: {},
  avatarMap: {},
  avatarRequests: {},
  avatarProviderId: null,
  avatarRequestId: null,
  avatarScope: null, // Session/provider identity; bulk invalidation must not change it.
};

function clearAvatarRequest(requests, userId, kind) {
  const pending = {...requests[userId]};
  delete pending[kind];
  if (pending.read || pending.write) requests[userId] = pending;
  else delete requests[userId];
}

const reducers = (state = initState, action) => {
  const personalDetailsMap = { ...state.personalDetailsMap };
  const usersMap = { ...state.usersMap };

  const avatarMap = { ...state.avatarMap };
  const avatarRequests = { ...state.avatarRequests };

  let userId;
  switch (action.type) {
    case authUserActions.GET_USER_SUCCESS:
      if (state.avatarProviderId === action.user.providerId) return state;
      return {
        ...state, avatarProviderId: action.user.providerId, avatarScope: action,
        avatarRequestId: null, avatarMap: {}, avatarRequests: {}
      };
    case providerUserActions.GET_ALL_USER_AVATARS_REQUEST:
      if (state.avatarScope !== action.ids.scope || state.avatarProviderId !== action.ids.providerId) return state;
      if (state.avatarRequestId !== action.ids.previousRequestId && state.avatarRequestId !== action.ids.requestId) return state;
      return {...state, avatarRequestId: action.ids.requestId};
    case providerUserActions.UPDATE_USER_AVATAR_REQUEST:
    case providerUserActions.DELETE_USER_AVATAR_REQUEST:
      avatarRequests[action.userId] = {write: action.avatarScope};
      return {...state, avatarRequestId: action.avatarScope, avatarRequests};
    case providerUserActions.UPDATE_USER_AVATAR_SUCCESS:
    case providerUserActions.DELETE_USER_AVATAR_SUCCESS:
      // Any read started before this write completed may contain an old URL.
      delete avatarRequests[action.userId];
      return {...state, avatarRequestId: action.avatarScope, avatarRequests};

    case providerUserActions.GET_LIST_SUCCESS:
      action.payload.forEach((user) => {
        // console.log(user.userId, user.firstName, user.lastName);
        usersMap[user.userId] = user;
      });
      return {
        ...state,
        usersMap: usersMap,
      };
    // case actions.GET_SERVICE_USER_REQUEST:
    //   return reduceDataRequest(state, 'personalDetails')
    case actions.GET_SERVICE_USER_SUCCESS:
      userId = action.payload.user.userId;
      personalDetailsMap[userId] = action.payload;
      avatarMap[userId] = action.payload.avatarUrl;
      return {
        ...state,
        personalDetailsMap: personalDetailsMap,
      };
    case actions.GET_USER_AVATAR_REQUEST:
    case providerUserActions.GET_USER_AVATAR_REQUEST:
      avatarRequests[action.userId] = {...avatarRequests[action.userId], read: action.avatarScope};
      return {
        ...state,
        avatarRequests: avatarRequests,
      };
    case actions.GET_USER_AVATAR_SUCCESS:
    case providerUserActions.GET_USER_AVATAR_SUCCESS:
      avatarMap[action.userId] = action.payload;
      clearAvatarRequest(avatarRequests, action.userId, 'read');
      return {
        ...state,
        avatarMap: avatarMap,
        avatarRequests: avatarRequests,
      };
    case actions.GET_USER_AVATAR_ERROR:
    case providerUserActions.GET_USER_AVATAR_ERROR:
      clearAvatarRequest(avatarRequests, action.userId, 'read');
      return {...state, avatarRequests};
    case providerUserActions.UPDATE_USER_AVATAR_ERROR:
    case providerUserActions.DELETE_USER_AVATAR_ERROR:
      clearAvatarRequest(avatarRequests, action.userId, 'write');
      return {
        ...state,
        avatarRequests: avatarRequests,
      };
    case providerUserActions.GET_ALL_USER_AVATARS_SUCCESS:
      if (state.avatarRequestId !== action.ids.requestId) return state;
      return {
        ...state,
        avatarMap: action.payload,
        avatarRequests: avatarRequests,
      };
    case auditActions.GET_ENTRIES_SUCCESS:
      return {
        ...state,
        avatarMap: _.assign(avatarMap, action.payload.avatarUrls),
      };
    default:
      return state;
  }
};

export default reducers;
